import { useContext } from "react"
import { GlobalStateContext } from "../components/providers/GlobalStateProvider.jsx"
import { useAuthenticatedFetch } from "./useAuthenticatedFetch.js"
import { AIStateContext } from "../components/providers/AIStateProvider.jsx"

export const useGetCreditsAvailable = () => {
	const authenticatedFetch = useAuthenticatedFetch()
	const { state } = useContext(GlobalStateContext)
	const { setAIState } = useContext(AIStateContext)
	const parentAccountId = state.storeOwners[state.shop]

	return ({ updateState }) => {
		return authenticatedFetch(
			`/api/ai/getCreditsAvailable?userId=${parentAccountId || state.userId}`,
		)
			.then((res) => res.json())
			.then((json) => {
				const creditsAvailable = json?.creditsAvailable ?? null

				if (updateState && creditsAvailable !== null) {
					setAIState({ creditsAvailable })
				}

				return creditsAvailable
			})
			.catch((err) => {
				console.error(err)
				return null
			})
	}
}

export const useCalculateTotalCreditsCostFromTokenEstimations = () => {
	const authenticatedFetch = useAuthenticatedFetch()

	return ({ tokenEstimations }) => {
		return authenticatedFetch(
			"/api/ai/calculateTotalCreditsCostFromTokenEstimations",
			{
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ tokenEstimations }),
			},
		)
			.then((res) => res.json())
			.then((json) => {
				return json?.totalEstimatedCost ?? null
			})
			.catch((err) => {
				console.error(err)
				return null
			})
	}
}
